// hooks/useIsPro.js
// ─────────────────────────────────────────────────────────
// Canonical Pro-check hook for all Learnlia components.
// Replaces the scattered inline checks that were inconsistent
// between TrackResourcePlayer and TrackAssessment.
//
// PLACEMENT: src/hooks/useIsPro.js
//
// USAGE:
//   import useIsPro from '../hooks/useIsPro';
//   const isPro = useIsPro();
// ─────────────────────────────────────────────────────────
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const GRACE_PERIOD_MS = 3 * 24 * 60 * 60 * 1000; // 3-day grace period for autopay processing & bank retries

export default function useIsPro() {
    const { user } = useContext(AuthContext);
    if (!user || user.subscription?.plan !== 'PRO') return false;
    
    // Status must be ACTIVE, HALTED (grace), or CANCELLED (access until end date)
    const validStatuses = ['ACTIVE', 'HALTED', 'CANCELLED'];
    if (!validStatuses.includes(user.subscription?.status)) return false;

    // Validate that current period + 3-day grace period has not expired
    if (!user.subscription?.currentPeriodEnd) return false;
    const expiry = new Date(user.subscription.currentPeriodEnd);
    if (isNaN(expiry.getTime())) return false;

    const effectiveExpiry = new Date(expiry.getTime() + GRACE_PERIOD_MS);
    return effectiveExpiry > new Date();
}